import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "5th Pair Option")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "form-horizontal" }
const _hoisted_4 = /*#__PURE__*/_createVNode("option", { value: "GC" }, "Product Rewards", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("option", { value: "TV" }, "PGI Rewards", -1)
const _hoisted_6 = { class: "card-header border-0 pt-5" }
const _hoisted_7 = { class: "card-title align-items-center" }
const _hoisted_8 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Transaction History", -1)
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = { class: "text-muted fw-semibold fs-8 text-uppercase" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Transaction ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Reference ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Amount ")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("td", {
  colspan: "3",
  class: "text-center text-muted py-10"
}, "No transaction history found.", -1)
const _hoisted_19 = { class: "ps-4" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_22 = { class: "fw-semibold text-gray-800" }
const _hoisted_23 = { class: "text-muted fs-8" }
const _hoisted_24 = { class: "fw-semibold text-gray-800" }
const _hoisted_25 = { class: "text-end pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    (_ctx.isAllowedFifthPairOption)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: [_ctx.widgetClasses, "card seq-card mb-6"]
        }, [
          _hoisted_1,
          _createVNode("div", _hoisted_2, [
            _createVNode("form", _hoisted_3, [
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pr_5th = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveFifthPairOptionFN())),
                class: "form-control m-l-39 dashboardFontStyle",
                style: {"width":"400px"}
              }, [
                _hoisted_4,
                _hoisted_5
              ], 544), [
                [_vModelSelect, _ctx.pr_5th]
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_6, [
        _createVNode("h3", _hoisted_7, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-line1.svg" })
          ]),
          _hoisted_9
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("table", _hoisted_12, [
            _createVNode("thead", null, [
              _createVNode("tr", _hoisted_13, [
                _createVNode("th", {
                  class: "ps-4 cursor-pointer user-select-none",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSort('transactiondesc')))
                }, [
                  _hoisted_14,
                  _createVNode("i", {
                    class: _ctx.sortIconClass('transactiondesc')
                  }, null, 2)
                ]),
                _createVNode("th", {
                  class: "cursor-pointer user-select-none",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSort('rusid')))
                }, [
                  _hoisted_15,
                  _createVNode("i", {
                    class: _ctx.sortIconClass('rusid')
                  }, null, 2)
                ]),
                _createVNode("th", {
                  class: "text-end pe-4 cursor-pointer user-select-none",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSort('txnamount')))
                }, [
                  _hoisted_16,
                  _createVNode("i", {
                    class: _ctx.sortIconClass('txnamount')
                  }, null, 2)
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_ctx.sortedList.length === 0)
                ? (_openBlock(), _createBlock("tr", _hoisted_17, [
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedList, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: _ctx.getRowKey(item, index)
                }, [
                  _createVNode("td", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("span", {
                        class: ["seq-row-icon me-3", _ctx.isCredit(item) ? 'seq-row-icon--green' : 'seq-row-icon--blue']
                      }, [
                        _createVNode("span", _hoisted_21, [
                          _createVNode(_component_inline_svg, {
                            src: _ctx.isCredit(item) ? 'media/icons/duotone/Navigation/Plus.svg' : 'media/icons/duotone/Navigation/Up-2.svg'
                          }, null, 8, ["src"])
                        ])
                      ], 2),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_22, _toDisplayString(_ctx.getItemField(item, 'transactiondesc')), 1),
                        _createVNode("div", _hoisted_23, "Ref #" + _toDisplayString(_ctx.getItemField(item, 'transactionID')) + " · " + _toDisplayString(_ctx.getItemField(item, 'txndte')), 1)
                      ])
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_24, _toDisplayString(_ctx.getItemField(item, 'rusid')), 1)
                  ]),
                  _createVNode("td", _hoisted_25, [
                    _createVNode("div", {
                      class: ["fw-semibold", _ctx.isCredit(item) ? 'seq-trend-up' : 'text-gray-800']
                    }, _toDisplayString(_ctx.numberWithCommas(_ctx.getItemField(item, 'txnamount'))), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}